module.exports = __webpack_public_path__ + "static/media/selbon_fnl-vid.cee12dfd.mp4";